/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Team_Manager_Import_Drop_HintInputs */



/**
* | output |
* | --- |
* | "One member per row, up to {max} rows" |
*
* @param {Team_Manager_Import_Drop_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_import_drop_hint = /** @type {((inputs: Team_Manager_Import_Drop_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Import_Drop_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Un membre par ligne, jusqu'à ${i?.max} lignes`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Ein Mitglied pro Zeile, bis zu ${i?.max} Zeilen`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Un membro per riga, fino a ${i?.max} righe`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Один участник на строку, до ${i?.max} строк`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Un miembro por fila, hasta ${i?.max} filas`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`每行一位成员，最多 ${i?.max} 行`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`1 行に 1 人、最大 ${i?.max} 行`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`प्रति पंक्ति एक सदस्य, अधिकतम ${i?.max} पंक्तियाँ`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Um membro por linha, até ${i?.max} linhas`)
	return /** @type {LocalizedString} */ (`One member per row, up to ${i?.max} rows`)
});